var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: !_vm.form.menuId ? "新增" : "修改",
        visible: _vm.visible,
        "append-to-body": "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "dataForm",
          attrs: { model: _vm.form, rules: _vm.rules, "label-width": "80px" },
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "菜单类型", prop: "menuType" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          attrs: { size: "small" },
                          model: {
                            value: _vm.form.menuType,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "menuType", $$v)
                            },
                            expression: "form.menuType",
                          },
                        },
                        [
                          _c("el-radio-button", { attrs: { label: "0" } }, [
                            _vm._v("左菜单"),
                          ]),
                          _c("el-radio-button", { attrs: { label: "1" } }, [
                            _vm._v("按钮"),
                          ]),
                          _c("el-radio-button", { attrs: { label: "2" } }, [
                            _vm._v("顶菜单"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "上级菜单" } },
                    [
                      _c("treeselect", {
                        attrs: {
                          options: _vm.menuOptions,
                          normalizer: _vm.normalizer,
                          "show-count": true,
                          placeholder: "选择上级菜单",
                        },
                        model: {
                          value: _vm.form.parentId,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "parentId", $$v)
                          },
                          expression: "form.parentId",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm.form.menuType !== "1"
            ? _c(
                "el-form-item",
                { attrs: { label: "图标", prop: "icon" } },
                [
                  _c("avue-input-icon", {
                    attrs: { "icon-list": _vm.iconList },
                    model: {
                      value: _vm.form.icon,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "icon", $$v)
                      },
                      expression: "form.icon",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-form-item",
            { attrs: { label: "名称", prop: "name" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入菜单名称" },
                model: {
                  value: _vm.form.name,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "name", $$v)
                  },
                  expression: "form.name",
                },
              }),
            ],
            1
          ),
          _vm.form.menuType !== "1"
            ? _c(
                "el-form-item",
                { attrs: { label: "路由地址", prop: "path" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入路由地址" },
                    model: {
                      value: _vm.form.path,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "path", $$v)
                      },
                      expression: "form.path",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm.form.menuType === "1"
            ? _c(
                "el-form-item",
                { attrs: { label: "权限标识", prop: "permission" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请权限标识", maxlength: "50" },
                    model: {
                      value: _vm.form.permission,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "permission", $$v)
                      },
                      expression: "form.permission",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "排序", prop: "sortOrder" } },
                    [
                      _c("el-input-number", {
                        attrs: { "controls-position": "right", min: 0 },
                        model: {
                          value: _vm.form.sortOrder,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "sortOrder", $$v)
                          },
                          expression: "form.sortOrder",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _vm.form.menuType !== "1"
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "路由缓冲", prop: "keepAlive" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.form.keepAlive,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "keepAlive", $$v)
                                },
                                expression: "form.keepAlive",
                              },
                            },
                            [
                              _c("el-radio-button", { attrs: { label: "0" } }, [
                                _vm._v("否"),
                              ]),
                              _c("el-radio-button", { attrs: { label: "1" } }, [
                                _vm._v("是"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _vm.form.menuType !== "1"
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "显示状态", prop: "visible" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.form.visible,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "visible", $$v)
                                },
                                expression: "form.visible",
                              },
                            },
                            [
                              _c("el-radio-button", { attrs: { label: "1" } }, [
                                _vm._v("显示"),
                              ]),
                              _c("el-radio-button", { attrs: { label: "0" } }, [
                                _vm._v("隐藏"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.dataFormSubmit } },
            [_vm._v("确 定")]
          ),
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  _vm.visible = false
                },
              },
            },
            [_vm._v("取 消")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }